import FAQ from './FAQ'
import { BREAKUP_COMPARISON, BREAKUP_FAQ_ITEMS } from './breakup-faq.data'

export default function BreakupFAQ() {
  return <FAQ items={BREAKUP_FAQ_ITEMS} productName="Хьюмантек" comparison={BREAKUP_COMPARISON} />
}
